/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type QuoteMoveTargetsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  quoteId: Types.Scalars['ID']['input'];
}>;


export type QuoteMoveTargetsQuery = { quote: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteResult', quote?: { __typename: 'Quote', id: string, items: Array<{ __typename: 'Item', id: string, parentId?: string | null, type: Types.ItemType, pathForPdf: string, pathSortable: string, title: string, originVersionNumber?: number | null, linkedQuoteTemplate?: { __typename: 'QuoteTemplate', id: string } | null }> } | null } };


export const QuoteMoveTargetsDocument = gql`
    query QuoteMoveTargets($projectId: ID!, $quoteId: ID!) {
  quote(projectId: $projectId, docId: $quoteId) {
    ... on QuoteResult {
      quote {
        id
        items {
          id
          parentId
          type
          pathForPdf
          pathSortable
          title
          originVersionNumber
          linkedQuoteTemplate {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useQuoteMoveTargetsQuery__
 *
 * To run a query within a React component, call `useQuoteMoveTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteMoveTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteMoveTargetsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useQuoteMoveTargetsQuery(baseOptions: Apollo.QueryHookOptions<QuoteMoveTargetsQuery, QuoteMoveTargetsQueryVariables> & ({ variables: QuoteMoveTargetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteMoveTargetsQuery, QuoteMoveTargetsQueryVariables>(QuoteMoveTargetsDocument, options);
      }
export function useQuoteMoveTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteMoveTargetsQuery, QuoteMoveTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteMoveTargetsQuery, QuoteMoveTargetsQueryVariables>(QuoteMoveTargetsDocument, options);
        }
export function useQuoteMoveTargetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuoteMoveTargetsQuery, QuoteMoveTargetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuoteMoveTargetsQuery, QuoteMoveTargetsQueryVariables>(QuoteMoveTargetsDocument, options);
        }
export type QuoteMoveTargetsQueryHookResult = ReturnType<typeof useQuoteMoveTargetsQuery>;
export type QuoteMoveTargetsLazyQueryHookResult = ReturnType<typeof useQuoteMoveTargetsLazyQuery>;
export type QuoteMoveTargetsSuspenseQueryHookResult = ReturnType<typeof useQuoteMoveTargetsSuspenseQuery>;
export type QuoteMoveTargetsQueryResult = Apollo.QueryResult<QuoteMoveTargetsQuery, QuoteMoveTargetsQueryVariables>;